<template>
  <el-dialog
    v-dialogDrag
    title="查看流程"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    class="mid-dialog"
    :append-to-body="true"
    @close="$emit('cancel')"
  >
    <div v-loading="loading" class="w-full h-full">
      <iframe v-if="flowSrc" :src="flowSrc" frameborder="0" class="w-full h-full"></iframe>
    </div>
  </el-dialog>
</template>

<script>
import { ColumnFlowApi } from '@wiz-api/workbench'

const columnFlowApi = new ColumnFlowApi()
export default {
  name: 'approvalFlowDialog',
  props: {
    id: {
      type: Number,
      default: 0,
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      },
    },
    flowServer() {
      return Wiz.GetModuleServer('road-flow-ele')
    },
    token() {
      return Wiz.AuthHooks.GetToken()
    },
  },
  data() {
    return {
      flowSrc: '', // 嵌入流程图的地址
      flowid: '',
      groupid: '',
      loading: false,
    }
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        this.init()
      }
    },
  },
  methods: {
    async init() {
      this.loading = true
      const [err, res] = await columnFlowApi.getFlowTaskInfo({
        flowTaskId: this.id,
      })
      if (!err) {
        this.flowid = res.flowId
        this.groupid = res.groupId
        this.flowSrc = `${this.flowServer}/index.html?loadurl=${encodeURIComponent(
          `/flow/run/process?flowid=${this.flowid}&groupid=${this.groupid}&status=-1`
        )}&nroadflow-token=${this.token}&isiframe=1`
      }
      this.loading = false
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-form-item__label {
  text-align: right;
}
::v-deep .el-tabs__content {
  height: calc(100% - 55px);
  overflow-y: auto;
}
</style>
